var $ = require('jquery');
require('flexslider');


var loadImageCarousel = function(i, el) {
  var $this = $(el),
      id = $this.data('id'),
      $carousel;
  $.get('/image_carousel/' + id, function (data) {
    $carousel = $(data);
    $carousel.insertAfter($this);
    $carousel.find('.texts').flexslider({
        controlNav: false,
        directionNav: false,
        fadeFirstSlide: false,
        animation: 'fade',
        touch: false
    });
    $carousel.find('.imgs').flexslider({
        controlNav: true,
        controlsContainer: '.controls',
        directionNav: false,
        fadeFirstSlide: false,
        animation: 'fade',
        touch: false,
        sync: '.texts'
    });

    $carousel.addClass('loaded');
  });
};

$(function () {
  $('.image-carousel-placeholder').each(loadImageCarousel);
});



//////////////////
// WEBPACK FOOTER
// ./common/js/image_carousel.js
// module id = 12
// module chunks = 0